var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"related-content-container"},[_c('div',{staticClass:"inner-content"},[_c('h2',[_vm._v("You may also be interested in:")]),_vm._t("related-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }